import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryShortcuts from '@/pages/home/components/CategoryShortcuts';
import SectionGrid from '@/pages/home/components/SectionGrid';
import SiteIntro from '@/pages/home/components/SiteIntro';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { getFeatured, getLatest, getMostViewed, getTopRated } from '@/lib/catalog';

export default function Home() {
  useDocumentMeta(
    '星辰影院—最新电影电视剧在线观看平台',
    '星辰影院提供丰富的电影和电视剧资源，涵盖多种类型和最新大片，方便用户在线观看和查找影视资讯。',
    '星辰影院,电影在线观看,电视剧播放,影视资源,最新电影,热门电视剧,高清影视',
  );

  const featured = getFeatured(5);
  const latestMovies = getLatest('movie', 6);
  const hotTv = getMostViewed(6, 'tv');
  const topRated = getTopRated(6);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main>
        <HeroCarousel items={featured} />

        <div className="-mt-10 relative z-20 md:-mt-14">
          <CategoryShortcuts />
        </div>

        <div className="mt-14 md:mt-20">
          <SectionGrid
            title="最新电影"
            subtitle="按上映时间为你呈现近期上线的电影作品"
            items={latestMovies}
            link={{ to: '/movies', label: '全部电影' }}
          />
        </div>

        <SectionGrid
          title="热门电视剧"
          subtitle="播放量与讨论度居高不下的热播剧集"
          items={hotTv}
          link={{ to: '/tvshows', label: '全部电视剧' }}
          tone="muted"
        />

        <SectionGrid
          title="高分推荐"
          subtitle="综合口碑与评分精选的必看佳作"
          items={topRated}
          link={{ to: '/search', label: '去搜索' }}
        />

        <SiteIntro />
      </main>

      <Footer />
    </div>
  );
}